export { default } from './NotificationsRightSidebar';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/NotificationsRightSidebar/index.js